export const version = "bignumber/5.2.0";
//# sourceMappingURL=_version.js.map